module.exports = __webpack_public_path__ + "img/sales.7ba46ed.svg";